import React, { forwardRef } from 'react';

import { Box } from '@mui/material';

import { MuiBaseTextFiled } from '@shared/ui-kit';

type PhoneNumberCustomProps = {
  isDisabled?: boolean;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isFullWidth?: boolean;
  isError?: boolean;
  label?: string;
  placeholder?: string;
  value?: string;
  errorMessage?: string;
  helperText?: string;
  size?: 'small' | 'medium';
  [x: string]: any;
};

const sx = {
  '& .MuiOutlinedInput-root': {
    paddingLeft: '38px',
  },
};

const PhoneNumberCustom = forwardRef<HTMLHeadingElement, PhoneNumberCustomProps>((props, ref) => {
  const {
    isDisabled,
    isError,
    isFullWidth,
    isRequired,
    isReadOnly,
    label,
    placeholder,
    helperText,
    errorMessage,
    value,
    size,
    ...args
  } = props;
  const isCustomHasValue = value ? value?.length > 2 : false;
  return (
    <Box>
      <MuiBaseTextFiled
        {...args}
        variant="outlined"
        label={label}
        value={value}
        ref={ref}
        isClearable={false}
        isFullWidth={isFullWidth}
        isDisabled={isDisabled}
        isRequired={isRequired}
        placeholder={placeholder}
        helperText={helperText}
        isCustomHasValue={isCustomHasValue}
        isError={isError}
        errorMessage={errorMessage}
        size={size}
        sx={sx}
        inputProps={{
          readOnly: isReadOnly,
        }}
      />
    </Box>
  );
});

export default PhoneNumberCustom;
